import React from "react";

import { faCalendarDays } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Icon } from "@performyard/py-components";
import type { MeetingModelJson } from "@performyard/service-contracts";

import { GoogleCalendarIcon } from "../../../UserSettings/Views/Calendar/components/GoogleCalendarIcon";
import { OutlookCalendarIcon } from "../../../UserSettings/Views/Calendar/components/OutlookCalendarIcon";

import { config } from "../config";

type MeetingCalendarIconProps = {
	meeting: MeetingModelJson;
};

/**
 * Displays a calendar icon based on the meeting's calendar integration status.
 * Shows provider-specific icon (Google/Outlook) if connected, otherwise generic calendar icon.
 */
const MeetingCalendarIcon = ({ meeting }: MeetingCalendarIconProps): React.ReactElement => {
	const iconSize = config.iconSize.medium;
	const containerStyle = {
		width: iconSize,
		height: iconSize,
	};
	const containerClassName = "flex items-center justify-center";

	if (!meeting.calendarEvent?.eventId) {
		return (
			<div className={containerClassName} style={containerStyle}>
				<Icon size={iconSize} icon={faCalendarDays} color="neutral-5" />
			</div>
		);
	}

	const calendarProvider = meeting.calendarEvent?.provider;

	if (calendarProvider === "google") {
		return (
			<div className={containerClassName} style={containerStyle}>
				<GoogleCalendarIcon size={iconSize} />
			</div>
		);
	}

	if (calendarProvider === "outlook") {
		return (
			<div className={containerClassName} style={containerStyle}>
				<OutlookCalendarIcon size={iconSize} />
			</div>
		);
	}

	return (
		<div className={containerClassName} style={containerStyle}>
			<Icon size={iconSize} icon={faCalendarDays} color="neutral-5" />
		</div>
	);
};

export default MeetingCalendarIcon;
